import ExitTrigger from '@mvps-genesis/exit-trigger';
import Checkout from 'extensions/checkout/Checkout.js';
import 'extensions/checkout/checkout.scss';
import 'extensions/proforma/components/x-installation-date-selector';
import 'extensions/proforma/components/x-proforma';
import {proformaStore} from 'extensions/proforma/data/proforma-store';
import {PageManager} from 'genesis-packages/core';

export default class PROFORMA_OSEL extends PageManager {

	constructor (pageContext) {

		super(pageContext);
		this.state = proformaStore.state;

	}

	onReady () {

		new ExitTrigger('.js-exit-trigger', {
			message: 'Are you sure you want to exit checkout?',
			redirectUrl: this.pageContext.Basket_Url
		});

		new Checkout();

		if (this.pageContext?.Customer_Permissions?.WebstorePricing) {
			const subtotalElement = document.querySelector('.t-basket__charge-amount');
			const totalElements = document.getElementsByClassName('js-basket-total-element');

			let subtotal = window.mivaJS.Proforma_Basket_Subtotal;
			let newAmount = parseFloat(this.calculateTotal());
			let formattedCurrency = new Intl.NumberFormat('en-AU', {
				currency: 'AUD',
				style: 'currency'
			}).format(subtotal + newAmount);
			subtotalElement.innerHTML = formattedCurrency;

			for (const totalElement of totalElements) {
				totalElement.innerHTML = formattedCurrency;
			}
		}

		const dateSelector = document.querySelector('x-installation-date-selector');
		if (dateSelector) {
			dateSelector.addEventListener('change', this.handleDateSelectorChange);
		}

	}

	calculateTotal () {
		let total = 0;
		for (const section in this.state) {
			let sectionTotal = 0;
			if (section !== 'id') {
				for (const prod of this.state[section]) {
					if (prod.productPrice && prod.productPrice !== '') {
						let prodTotal = prod.productPrice * prod.productQuantity;
						sectionTotal += prodTotal;
					}
				}
			}
			total += sectionTotal;
		};

		return total;
	}

}
